import { MatSnackBarConfig } from '@angular/material/snack-bar';
import { SubcatGraphStyle } from './services/result-data/result-data.service';

/**
 * Configuration object defining the standardized structure for input Excel files.
 *
 * This constant centralizes all configuration details required to correctly parse and
 * interpret the standardized Excel files uploaded by users.
 *
 * ⚠️ Important:
 * - If the standard Excel file format changes, update this object accordingly.
 * - Ensure to adjust any related parsing logic to reflect the new configuration.
 *

 * Usage:
 * - Import this object wherever standardized Excel parsing logic is implemented.
 * - Consistently use these constants to avoid hardcoding indexes or sheet names.
 */
export const EXCEL_FILE_STANDARD_DATA = {
  /**
   * Object containing standardized names for sheets in the Excel file.
   */
  SHEET_NAMES: {
    PARAMETERS: 'Paramètres',
    RESULTS: 'Résultats',
    SCENARIO: 'Scénario',
    CARE_PATHWAY: 'Parcours',
    INTRO: 'Intro',
    CONFIG: 'Config',
    SUMMARY: 'Synthèse',
  },

  RESULTS: {
    BUDGET_IMPACT: 'Impacts budgétaires',
    ORG_IMPACT: 'Impacts organisationnels',
    ORG_IMPACT_ABS: 'Impacts organisationnels (valeurs absolues)',
    ORG_IMPACT_REL: 'Impacts organisationnels (valeurs relatives)',
  },

  CARE_PATHWAY: {
    STEP_IMPACT_CATEGORIES: {
      BUDGET: 'Budgétaires',
      ORG: 'Organisationnels',
    },
  },
};

export const DATA_TYPES = {
  STRING: 'string',
  NUMBER: 'number',
};

export const HYPER_FORMULA_OPTIONS = {
  licenseKey: 'gpl-v3',
};

export const ERROR_SNACKBAR_CONFIG: MatSnackBarConfig = {
  horizontalPosition: 'right',
  verticalPosition: 'top',
  panelClass: 'error-snackbar',
};

export const TIME_HORIZON_SCENARIO_ROW_NAME = 'Horizon';
export const TIME_HORIZON_KEY_1Y = '1 an';
export const TIME_HORIZON_KEY_2Y = '2 ans';
export const TIME_HORIZON_KEY_3Y = '3 ans';
export const TIME_HORIZON_KEY_4Y = '4 ans';
export const TIME_HORIZON_KEY_5Y = '5 ans';

export const MAT_TAB_ICONS = {
  [EXCEL_FILE_STANDARD_DATA.RESULTS.BUDGET_IMPACT]: 'payments',
  [EXCEL_FILE_STANDARD_DATA.RESULTS.ORG_IMPACT]: 'workspaces',
  [EXCEL_FILE_STANDARD_DATA.RESULTS.ORG_IMPACT_ABS]: 'workspaces',
  [EXCEL_FILE_STANDARD_DATA.RESULTS.ORG_IMPACT_REL]: 'group_work',
  [EXCEL_FILE_STANDARD_DATA.RESULTS.ORG_IMPACT_REL]: 'group_work',
  [EXCEL_FILE_STANDARD_DATA.CARE_PATHWAY.STEP_IMPACT_CATEGORIES.BUDGET]:
    'payments',
  [EXCEL_FILE_STANDARD_DATA.CARE_PATHWAY.STEP_IMPACT_CATEGORIES.ORG]:
    'workspaces',
};

export const DEFAULT_SUBCAT_GRAPH_STYLE: SubcatGraphStyle = 'bar';

export const DEFAULT_CARD_TITLE = '[TITRE VIDE]';
export const DEFAULT_CARD_SUBTITLE = '[SOUS TITRE VIDE]';
export const DEFAULT_TIME_SERIES_COLSPAN = 7;
export const DEFAULT_PIE_CHART_COLSPAN = 4;
export const DEFAULT_TITLE_CARD_COLSPAN = 3;
export const DEFAULT_DATA_POINT_SINGLE_COLSPAN = 3;
export const DEFAULT_DATA_POINT_DOUBLE_COLSPAN = 5;
